import { gql } from '@apollo/client';

export const GET_ORDER_DETAILS = gql`
  query GetOrderDetails($orderId: ID!) {
    getOrder(orderId: $orderId) {
      __typename
      ... on ReadOrderSuccess {
        code
        order {
          id
          code
          status {
            id
            name
            index
          }
          statusHistory {
            timestamp
            status {
              id
              index
              name
            }
          }
          orderDate
          totalValue
          itemCount
          commerce
          returnMethod {
            id
            name
            index
            info {
              ... on CliqueRetireOrderInfo {
                expressNumber
                boxCode
                cliqueRetireOrderId
                qrCodeUrl
              }
              ... on CorreiosOrderInfo {
                correiosObjectTag
                correiosPostageNumber
              }
            }
          }
          note
          externalOrderCode
          client {
            id
            email
            phone
            document
            name
            address {
              street
              number
              complement
              district
              city
              state
              zipCode
              reference
            }
          }
          items {
            id
            name
            price
            category {
              id
              name
            }
            quantity
            externalId
            imageUrl
            reason {
              id
              description
            }
            resolution
          }
        }
      }
      ... on Error {
        code
        message
      }
    }
  }
`;
